import { render } from "./TransactionDetailSkeleton.vue?vue&type=template&id=829520bc&scoped=true"
import script from "./TransactionDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./TransactionDetailSkeleton.vue?vue&type=script&lang=js"

import "./TransactionDetailSkeleton.vue?vue&type=style&index=0&id=829520bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829520bc"]])

export default __exports__